import { render, staticRenderFns } from "./Posts.vue?vue&type=template&id=522583f8&"
import script from "./Posts.vue?vue&type=script&lang=js&"
export * from "./Posts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports